export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Active = "active",
	Complete = "complete",
}

export enum TournamentStatus {
	Scheduled = "scheduled",
	Active = "active",
	Complete = "complete",
}

export enum ShareType {
	FB,
	TW,
	MOBILE,
	League = "league",
	General = "general",
	Prediction = "prediction",
}

export enum Language {
	English = "en",
	French = "fr",
}

export enum LinksType {
	FIRST,
	SECOND,
	WITH_IMAGE,
	EMPTY,
}

export enum ModalType {
	ERROR,
	TERMS,
	TUTORIAL,
	SUCCESS,
	PICKSSAVED,
	PREDICTIONSSHARE,
	LEAGUE_USER_REMOVE,
	LEAGUE_REMOVE,
	LEAGUELEAVE,
	LEAVE_PICKS,
}

export enum LandingCardType {
	default,
}

export enum LeaguePrivacy {
	Public = "public",
	Private = "private",
}

export enum SocialNetwork {
	FACEBOOK,
	TWITTER,
	MOBILE,
}

export enum PrivacyType {
	Private = "private",
	Public = "public",
}

export enum LeagueType {
	TotalScore = "regular",
}

export enum TutorialStep {
	Slider = "slider",
	Finish = "finish",
}

export enum ConnextraType {
	HOME_PAGE = "homepage",
	PICK_CONFIRM = "pickconfirm",
	SHARE_CLICK = "shareclick",
	EMAIL_OPTIN = "emailoptin",
}

export enum PickemWidgetType {
	Pick = "pick",
	Stats = "stats",
}
